module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "deals"
    }
  }, [_c('route-list-selector', {
    ref: "RouteListSelector"
  }), _c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "content-area",
    attrs: {
      "md-theme": "white"
    }
  }, [(Object.keys(_vm.statuses)) ? _c('sort-table', {
    ref: "delastable",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.count,
      "total": _vm.dealsAmount,
      "link": "link",
      "table-id": "deals",
      "default-order": "desc",
      "default-sort": "id",
      "selected-field": "select",
      "select-item-field": "first_freight_id",
      "noBreackColumns": ['traking_number', 'id'],
      "loadOnScroll": true,
      "refreshOnCreate": true,
      "cursorPagination": true,
      "isLastPage": _vm.isLastPage
    },
    on: {
      "refresh": _vm.getDeals,
      "change-selected": _vm.changeSelected,
      "create": _vm.addDeal
    },
    scopedSlots: _vm._u([{
      key: "first_freight.weight",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.first_freight && scope.item.first_freight.weight) ? scope.item.first_freight.weight : 'Не установлен'))])]
      }
    }, {
      key: "first_freight.size",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.first_freight && scope.item.first_freight.size) ? scope.item.first_freight.size : 'Не установлен'))])]
      }
    }, {
      key: "first_freight.seats_number",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.first_freight && scope.item.first_freight.seats_number) ? scope.item.first_freight.seats_number : 'Не установлен'))])]
      }
    }, {
      key: "id",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "no-breack-words"
        }, [_vm._v(_vm._s((scope.item.first_freight) ? scope.item.first_freight.traking_number : ''))])]
      }
    }, {
      key: "route_lists",
      fn: function(scope) {
        return [(scope.item.route_lists && scope.item.route_lists.length) ? _c('div', {
          staticClass: "router-list-container"
        }, [_c('div', {
          staticClass: "router-lists",
          class: {
            'many': (scope.item.route_lists.length > 1)
          }
        }, _vm._l((scope.item.route_lists), function(routeList) {
          return _c('div', {
            key: routeList.id,
            staticClass: "router-list-link",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                $event.preventDefault();
                _vm.openRouteList(routeList.id)
              }
            }
          }, [_vm._v(_vm._s(routeList.id))])
        }))]) : _vm._e()]
      }
    }, {
      key: "sender.name",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "no-break-hidden"
        }, [_c('span', [_vm._v(_vm._s((scope.item.sender ? scope.item.sender.name : '')))])])]
      }
    }, {
      key: "recipient.name",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "no-break-hidden"
        }, [_c('span', [_vm._v(_vm._s(scope.item.recipient ? scope.item.recipient.name : ''))])])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [(scope && scope.item && scope.item.id) ? _c('ZDealStatusChanger', {
          attrs: {
            "deal-id": scope.item.id,
            "disabled": !!(scope.item && scope.item.route_lists && scope.item.route_lists.length > 0),
            "hide-label": "hide-label"
          },
          model: {
            value: (scope.item.status_id),
            callback: function($$v) {
              _vm.$set(scope.item, "status_id", $$v)
            },
            expression: "scope.item.status_id"
          }
        }) : _vm._e()]
      }
    }, {
      key: "frstatus",
      fn: function(scope) {
        return [(scope.item.first_freight && scope.item.first_freight.currenttracking && scope.item.first_freight.currenttracking.status_id && _vm.getStatus(scope.item.first_freight.currenttracking.status_id, 0)) ? _c('div', {
          staticClass: "no-break-hidden",
          style: ('color: ' + _vm.getStatus(scope.item.first_freight.currenttracking.status_id, 2))
        }, [_c('span', [_vm._v(_vm._s(_vm.getStatus(scope.item.first_freight.currenttracking.status_id, 1)))])]) : _c('div', {
          staticClass: "no-break-hidden"
        }, [(scope.item.first_freight && scope.item.first_freight.status && scope.item.first_freight.status.name) ? _c('span', {
          style: ('color: ' + _vm.getStatus(scope.item.first_freight.status_id, 2))
        }, [_vm._v(_vm._s(scope.item.first_freight.status.name))]) : _c('span', [_vm._v("Не установлен")])])]
      }
    }, {
      key: "created_at",
      fn: function(scope) {
        return [_vm._v(_vm._s(((scope.item.created_at) ? _vm.moment(scope.item.created_at).format('DD.MM.YYYY') : '')))]
      }
    }, {
      key: "first_freight.services",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.HasTempReg(scope.item.first_freight) ? 'Да' : 'Нет'))])]
      }
    }, {
      key: "from",
      fn: function(scope) {
        return [(parseInt(scope.item.delivery_method_from) === 1) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [(scope.item.from_stock) ? _c('span', [_vm._v(_vm._s(scope.item.from_stock.name))]) : (scope.item.from_city) ? _c('span', [_vm._v(_vm._s(scope.item.from_city.name))]) : _vm._e()]) : _vm._e(), (parseInt(scope.item.delivery_method_from) === 2) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [(scope.item.from_address) ? _c('span', [_vm._v(_vm._s(scope.item.from_address.address))]) : (scope.item.from_city) ? _c('span', [_vm._v(_vm._s(scope.item.from_city.name))]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [(parseInt(scope.item.delivery_method_to) === 1) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [(scope.item.to_stock) ? _c('span', [_vm._v(_vm._s(scope.item.to_stock.name))]) : (scope.item.to_city) ? _c('span', [_vm._v(_vm._s(scope.item.to_city.name))]) : _vm._e()]) : _vm._e(), (parseInt(scope.item.delivery_method_to) === 2) ? _c('div', {
          staticClass: "no-break-hidden"
        }, [(scope.item.to_address) ? _c('span', [_vm._v(_vm._s(scope.item.to_address.address))]) : (scope.item.to_city) ? _c('span', [_vm._v(_vm._s(scope.item.to_city.name))]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "closest_departure_date",
      fn: function(scope) {
        return [_vm._v(_vm._s(((scope.item.closest_departure_date) ? _vm.moment(scope.item.closest_departure_date).format('DD.MM.YYYY') : '')))]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('span', [_c('md-button', {
          staticClass: "md-icon-button md-dense small",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.clone(scope.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-clone"
        })]), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("Клонировать")])], 1)]
      }
    }]),
    model: {
      value: (_vm.deals),
      callback: function($$v) {
        _vm.deals = $$v
      },
      expression: "deals"
    }
  }, [(_vm.selectedFreights && _vm.selectedFreights.length) ? _c('template', {
    slot: "head"
  }, [(_vm.isUserAdmin) ? _c('md-button', {
    staticClass: "md-dense md-accent",
    on: {
      "click": _vm.removeDeals
    }
  }, [_vm._v("Удалить заявки")]) : _vm._e(), (!_vm.selectedCanceledFreights.length && !_vm.selectedAcceptedFreights.length) ? _c('md-button', {
    staticClass: "md-dense md-primary",
    on: {
      "click": _vm.createRouteList
    }
  }, [_vm._v("Создать маршрутный лист")]) : _vm._e(), (!_vm.selectedCanceledFreights.length && !_vm.selectedAcceptedFreights.length) ? _c('md-button', {
    staticClass: "md-dense md-default",
    on: {
      "click": _vm.addToRouteList
    }
  }, [_vm._v("Добавить к маршрутному листу")]) : _vm._e()], 1) : _vm._e(), _c('template', {
    slot: "buttons"
  }, [_c('md-button', {
    staticClass: "md-dense",
    on: {
      "click": _vm.addDeal
    }
  }, [_vm._v("Добавить "), _c('md-icon', [_vm._v("add")])], 1), (_vm.isUserAgent) ? _c('md-button', {
    staticClass: "md-dense md-primary",
    on: {
      "click": _vm.addAgentDeal
    }
  }, [_vm._v("Принять груз "), _c('md-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 2) : _vm._e(), _c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v("Удалить заявку " + _vm._s((_vm.dealToDelete && _vm.dealToDelete.first_freight && _vm.dealToDelete.first_freight.traking_number) ? _vm.dealToDelete.first_freight.traking_number + '?' : '?'))]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteDeal(_vm.dealToDelete.id)
      }
    }
  }, [_vm._v("Удалить")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39419902","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/Deals.vue
// module id = 1109
// module chunks = 0